import React, { useState, useEffect } from 'react'
import { useHover } from 'react-use'
import Info from '../Svgs/Info'
import classNames from 'classnames'
import styles from './Checkbox.module.scss'
import { $TSFixMe } from 'types/ts-migrate'
import Tooltip from '../Tooltip/Tooltip'

type TProps = {
  id?: string
  disabled?: boolean
  label?: string | React.ReactElement
  labelHint?: string
  name: string
  placeholder?: string
  checked?: boolean
  error?: React.ReactNode
  onChange?: (e: $TSFixMe) => void
  onBlur?: (e: $TSFixMe) => void
  className?: string
}

const Checkbox = ({
  id,
  disabled,
  label,
  labelHint,
  name,
  checked: checkedProp = false,
  error,
  onChange,
  className,
}: TProps) => {
  const [isFocused, setIsFocused] = useState(false)
  const [checked, setChecked] = useState(checkedProp)

  useEffect(() => {
    setChecked(checkedProp)
  }, [checkedProp])

  const handleChange = (e: any): void => {
    const { checked: targetChecked } = e.target
    setChecked(!targetChecked)
    if (typeof onChange === 'function') {
      onChange({ ...e, checked: targetChecked })
    }
  }

  const inputId = id || name

  const classes = classNames([styles.root, className], {
    [styles['is-focused']]: isFocused,
    [styles['is-checked']]: checked,
    [styles['has-error']]: error,
    [styles['is-disabled']]: disabled,
    [styles['has-label-hint']]: labelHint,
  })

  const [hoverableInfoIcon, isHovering] = useHover(
    <div className={styles['info-icon']}>
      <Info width={20} height={20} />
    </div>,
  )

  return (
    <div className={classes}>
      <label htmlFor={inputId}>
        <input
          id={inputId}
          disabled={disabled}
          name={name}
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />
        <span>
          {label && label}
          {error && ` - ${error as string}`}
          {labelHint && (
            <Tooltip isOpen={isHovering} body={labelHint}>
              {hoverableInfoIcon}
            </Tooltip>
          )}
        </span>
      </label>
    </div>
  )
}

export default Checkbox
